"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getContractAdditionalDetails = getContractAdditionalDetails;
exports.getContractConsumptionDetails = getContractConsumptionDetails;
exports.getContractConsumptions = getContractConsumptions;
exports.getContracts = getContracts;
exports.getHanAccessDetails = getHanAccessDetails;
var _axios = _interopRequireDefault(require("axios"));
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function getContracts(token) {
  var config = token ? {
    headers: {
      'X-Ciam-Token': token
    }
  } : {};
  var auth = !token;
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts?projection=withBusinessPartner"), {}, config, true, auth);
  }, 'contractaccounts');
}
function getContractConsumptions(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/consumption/v0/contractconsumptions?contractAccountId=").concat(contractAccountId));
}
function getContractConsumptionDetails(contractAccountId, contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/meterreading/v0/readingresults?contractAccountId=").concat(contractAccountId, "&contractId=").concat(contractId));
}
function getContractAdditionalDetails(contractAccountId) {
  var response = _CacheHandler.default.requestCache(function () {
    var baseURL = _RestHelper.default.getBaseUrl();
    return _RestHelper.default.get("".concat(baseURL, "/cscn-customer-srv/api/partner/v0/contracts?contractAccountId=").concat(contractAccountId), {}, {});
  }, "additionalDetails_".concat(contractAccountId));
  return {
    request: new Promise(function (resolve, reject) {
      response.then(function (responseData) {
        resolve(responseData);
      }).catch(function (err) {
        var error = err;
        if (_axios.default.isCancel(error)) {
          error.type = 'cancel';
        }
        reject(error);
      });
    })
  };
}
function getHanAccessDetails(contractAccountId, meterSerialNumber) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/contractaccounts/").concat(contractAccountId, "/gatewayaccount/").concat(meterSerialNumber));
}
var _default = exports.default = {
  getContracts: getContracts,
  getHanAccessDetails: getHanAccessDetails,
  getContractAdditionalDetails: getContractAdditionalDetails,
  getContractConsumptionDetails: getContractConsumptionDetails,
  getContractConsumptions: getContractConsumptions
};